<app-component-header></app-component-header>
<div class="component-block">
    <div class="row flex-display">
        <div class="col-md-12">
            <h1 style="font-size:72px;">204</h1>
            <p class="text-error" style="color:unset !important;text-shadow:unset !important;">No Content (204)!</p>
            <p class="textcontent-error" style="color:unset !important;text-shadow:unset !important;font-size: 12px;">The server has successfully fulfilled the request <br />and that there is no additional content to send in the response payload body.</p>
        </div>
    </div>
    <div class="row my-3">
        <div class="div-center">
            <button nz-button nzType="primary" nzSize="large" nzShape="round" class="btn-sacom-o" (click)="goToDefaultPage()">
                Trở về Trang chủ
            </button>
        </div>
    </div>
</div>

<app-component-footer></app-component-footer>